import { supabase } from '@/core/database/supabase';
import type { SubTask, WorkOrderInfo, SubTaskStats } from '../types/subTask.types';

export const subTaskService = {
  async getWorkOrderInfo(workOrderId: string): Promise<WorkOrderInfo> {
    const { data, error } = await supabase
      .from('work_orders')
      .select('*')
      .eq('id', workOrderId)
      .single();

    if (error) throw error;
    
    // In a real app, you'd join with profiles, but here we return a mapped object
    return {
      id: data.id,
      title: data.title || 'Trồng cây xanh tuyến đường chính',
      type: data.type || 'construction',
      location: 'Khu đô thị Eco Garden',
      code: data.order_code || 'CV-2024-0156',
      status_code: data.status_code || 'in_progress',
      total_progress: 60,
      completed_count: 6,
      total_count: 10,
      manager_name: 'Trần Minh Tuấn',
      due_date: '2024-05-30',
    };
  },

  async getSubTasks(workOrderId: string): Promise<{ items: SubTask[], stats: SubTaskStats }> {
    const { data, error } = await supabase
      .from('work_order_sub_tasks')
      .select(`
        *,
        assigned_to:user_profiles!assigned_to_id(id, full_name, avatar_path)
      `)
      .eq('work_order_id', workOrderId)
      .order('created_at', { ascending: true });

    if (error) throw error;

    const items = data as SubTask[];
    
    const stats: SubTaskStats = {
      total: items.length,
      completed: items.filter(t => t.status_code === 'completed').length,
      inProgress: items.filter(t => t.status_code === 'in_progress').length,
      pending: items.filter(t => t.status_code === 'pending').length,
      overdue: items.filter(t => t.status_code === 'overdue').length,
      priorityStats: {
        high: items.filter(t => t.priority_code === 'high').length,
        medium: items.filter(t => t.priority_code === 'medium').length,
        low: items.filter(t => t.priority_code === 'low').length,
      }
    };

    return { items, stats };
  }
};
